import React, { useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import './FileViewer.scss';
interface FileViewerProps {
  fileUrl: string;
  onClose: () => void;
}

const FileViewer: React.FC<FileViewerProps> = ({ fileUrl, onClose }) => {
  const [show, setShow] = useState<boolean>(fileUrl ? true : false);
  return (
    <>
      <Modal
        className="petsked-modal-dialog file-viewer-dialog"
        show={show}
        onHide={() => {
          setShow(false);
          onClose();
        }}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <img className="image-feed" src={fileUrl} alt="Preview" />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FileViewer;
